import React from "react";
import {
  IonIcon,
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonTitle,
  IonContent,
  IonProgressBar, withIonLifeCycle,
} from "@ionic/react";
import {arrowBack} from "ionicons/icons";
import AbaAnexo from "./AbaAnexo";
import {AnexoObject} from "../../models/Anexo";
import fb from "../../lib/firebase";
import {goBackNG, sanitizeText} from "../../lib/utils";
import truncate from "lodash/truncate";
import {connect} from "react-redux";
import {AppDispatch, RootState} from "../../global.state";
import {AppState} from "../../models/app";


interface Props {
  app: AppState;
  dispatch: AppDispatch;
  history: any;
  match: any;
}

interface State {
  selectedTab: string;
  instance: AnexoObject | undefined;
  loading: boolean;
}

class Anexo extends React.Component<Props, State> {
  private cancelListener: () => void;

  constructor(props: Props) {
    super(props);

    this.state = {
      selectedTab: "home",
      instance: undefined,
      loading: true,
    };

    this.cancelListener = () => {};
  }

  ionViewWillEnter() {
    // reset state
    const instanceId = this.props.match.params.instanceId;
    const instance = this.state.instance;
    if ( !instance || instance.id !== instanceId) {
      this.setState({instance: undefined, loading: true, selectedTab: "home"});
    }

    this.installListener();
  }
  ionViewDidLeave() {
    this.cancelListener();
  }

  installListener = () => {
    const doc = fb.db.collection('anexos').doc(this.props.match.params.instanceId);
    this.cancelListener = doc.onSnapshot((snap) => {
      this.setState({
        instance: fb.doc(snap) as AnexoObject,
        loading: false,
      });
    });
  };

  onChangeTab = (selectedTab:string) => {
    this.setState({selectedTab});
  };

  onClickBack = () => {
    goBackNG(this.props.app.jumpHistory, this.props.dispatch, this.props);
  };

  render() {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonButton onClick={this.onClickBack}>
                <IonIcon slot="start" icon={arrowBack}/>
              </IonButton>
            </IonButtons>
            <IonTitle className="font-condensed">
              {this.state.instance &&
                `Anexo: ${truncate(sanitizeText(this.state.instance.descricao), {length: 32})}`}
            </IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          {
            !this.state.instance ? <IonProgressBar type="indeterminate"/> :
              <AbaAnexo
                instance={this.state.instance}
                goBack={this.onClickBack}
                loading={this.state.loading}
              />
          }
        </IonContent>
      </IonPage>
    );
  }
}

export default connect(({app}: RootState) => ({app}))(withIonLifeCycle(Anexo));